import { gql } from "@apollo/client";

const UserPresentationByTokenQuery = gql`
  query UserPresentationByTokenQuery($token: String!) {
    userPresentationByToken(token: $token) {
      presentationId
      firstName
      age
      city
      height
      summary
      selectedPhotos {
        uri(size: "rectangle")
      }
      decision {
        accept
        decisionAt
        presentationId
        suggestedTimes
      }
      readerDecision {
        accept
        motivation
        decisionAt
        presentationId
        suggestedTimes
      }
      rejectedTimes
      decidedTimes
    }
  }
`;

export default UserPresentationByTokenQuery; 
